/********************************************************************************
Filename: np-compare-grid.js
Created: 12 Apr 2021
Author: Ron Robertson
Description: Creates a grid to compare products.
Usage Example:
<np-compare-grid></np-compare-grid>
********************************************************************************/


(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            .npCompareGridHeader{
                display:flex;
                justify-content:space-between;
                padding:25px 0;
                padding-left:calc((var(--col-width) * 2) + (var(--gutter-width) * 2));


                position: sticky;
                top: 60px;
                background-image: linear-gradient(to bottom, rgba(255,255,255,1) 85%, rgba(255,255,255,0));
                z-index:7;
            }

            .npCompareGridHeader > *{
                width: calc((var(--col-width) * 2) + var(--gutter-width));
                text-align:center;
                font-family: var(--bodyFontFamily);
                font-size: var(--bodyFontSize);
            }

            .hwKeyLink{
                color:purple;
            }

            /* Small Down */
            @media screen and (max-width:767px) {
                #npCompareGridSelect2{
                    display:none;
                }
            }

            /* Medium Down */
            @media screen and (max-width:959px) {
                #npCompareGridSelect3{
                    display:none;
                }
            }

            /* Large Down */
            @media screen and (max-width:1199px) {
                #npCompareGridSelect4{
                    display:none;
                }
            }

            /* Medium */
            @media screen and (min-width: 768px) and (max-width:959px) {
                .npCompareGridHeader{
                    padding-left:calc((var(--col-width) * 3) + (var(--gutter-width) * 3));
                }
                .npCompareGridHeader > *{
                    width: calc((var(--col-width) * 3) + (var(--gutter-width) * 2));
                }
            }
            /* Large */
            @media screen and (min-width: 960px) and (max-width:1199px) {
                .npCompareGridHeader{
                    padding-left:calc((var(--col-width) * 3) + (var(--gutter-width) * 3));
                    padding-right:calc((var(--col-width) * 1) + (var(--gutter-width) * 1));
                }
            }

        </style>

        <div id="np-compare-grid">
            <div class="npCompareGridHeader">
                <np-select id="npCompareGridSelect0" theme='grayBox'></np-select>
                <np-select id="npCompareGridSelect1" theme='grayBox'></np-select>
                <np-select id="npCompareGridSelect2" theme='grayBox'></np-select>
                <np-select id="npCompareGridSelect3" theme='grayBox'></np-select>
                <np-select id="npCompareGridSelect4" theme='grayBox'></np-select>
            </div><!--END npCompareGridHeader-->
            <div class="npCompareGridBody">
                <slot></slot>
            </div><!--END npCompareGridBody-->
        </div><!--END np-compare-grid-->
    `;

    class NpCompareGrid extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            this.loadData = this.loadData.bind(this);
            this.loadHiddenPrices = this.loadHiddenPrices.bind(this);
            this.populateHeader = this.populateHeader.bind(this);
            this.loadVersionData = this.loadVersionData.bind(this);
            this.selectChangeEvent = this.selectChangeEvent.bind(this);
            this.symbolRenderer = this.symbolRenderer.bind(this);
            this.keyLinkRenderer = this.keyLinkRenderer.bind(this);

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.npCompareGrid = this.shadowRoot.getElementById("np-compare-grid");
            this.select0= this.shadowRoot.getElementById("npCompareGridSelect0");
            this.select1= this.shadowRoot.getElementById("npCompareGridSelect1");
            this.select2= this.shadowRoot.getElementById("npCompareGridSelect2");
            this.select3= this.shadowRoot.getElementById("npCompareGridSelect3");
            this.select4= this.shadowRoot.getElementById("npCompareGridSelect4");

            /* Holds the version data loaded from JSON */
            this.loadedData=[];

            /* Holds which versions are being displayed */
            this.displayedData=['621','617','606','619','608'];

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            if (!this.hasAttribute('dataUrl')) {
                this.setAttribute('dataUrl', "");
            }

            this.select0.addEventListener('change', this.selectChangeEvent);
            this.select1.addEventListener('change', this.selectChangeEvent);
            this.select2.addEventListener('change', this.selectChangeEvent);
            this.select3.addEventListener('change', this.selectChangeEvent);
            this.select4.addEventListener('change', this.selectChangeEvent);

            this.loadData();

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['dataUrl'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

        if(name === 'dataUrl') {
            this.loadData(dataUrl);
        }
       }/* END attributesChangedCallback */

      /* Getting attributes */
      get dataUrl() {
        return this.getAttribute('dataUrl');
      }

      /* Settinng attributes */
      set dataUrl(newValue) {
        this.setAttribute('dataUrl', newValue);
      }


        /*** Methods ***/

        /* Load data from external json file */
        loadData() {
            $.getJSON(this.dataUrl, (json) => {
                /* Saves the loaded data */
                this.loadedData = json;

                /* Adds the prices hidden on the page to the data */
                this.loadHiddenPrices();
            });
        }

        loadHiddenPrices() {
            //loops through versions
            for(var i=0; i < this.loadedData.length; i++){
                //if there is a hidden price on the page that matches this product index
                if(document.getElementById('product'+this.loadedData[i].productIndex)){
                    //add the price to the data
                    this.loadedData[i].price = document.getElementById('product'+this.loadedData[i].productIndex).innerHTML;
                }

                //if there is a hidden price on the page that matches this maintenance update index
                if(document.getElementById('product'+this.loadedData[i].updatesProductIndex)){
                    //add the maintenance price to the data
                    this.loadedData[i].updatesPrice = document.getElementById('product'+this.loadedData[i].updatesProductIndex).innerHTML;
                }
            }

            /* Creates the header */
            this.populateHeader();
        }


        /* Populates the grid header with select boxes */
        populateHeader() {

            var parameters = null;
            /* Get part of the URL starting with '?' */
            if(window.location.search.length > 0) {
                parameters = window.location.search;

                /* remove the '?versions=' */
                parameters = parameters.split("?versions=").pop();

                /* Create array and remove '&' */
                parameters = parameters.split("&");

                parameters.push(...this.displayedData);
            }

            if(parameters != null) {
                this.displayedData = parameters;
            }

            /* Loops through once for each select */
            for(var s=0; s < 5; s++){
                var select = this['select'+s];
                var selectedSet = false;

                /* Create a 'blank' option */
                var blankOption = document.createElement("np-select-option");
                blankOption.innerHTML = "None<br>&nbsp;";
                select.appendChild(blankOption);
                blankOption.setAttribute('value','none');
                blankOption.setAttribute('placeholder','Select a version');

                /* Set if 'none' is in the url for this column */
                if(this.displayedData[s] === "none"){
                    blankOption.setAttribute('selected','');
                }

                /* Populating the selects with the motive versions from the json file */
                for(var i=0; i < this.loadedData.length; i++){
                    var option = document.createElement("np-select-option");
                    var name = this.loadedData[i].name;

                    /* Creating the option */
                    select.appendChild(option);
                    option.innerHTML = name;
                    option.setAttribute('value', this.loadedData[i].productIndex);


                    /* Select this option if passed in the url for this column */
                    if(!selectedSet && this.loadedData[i].productIndex.toString() === this.displayedData[s]){
                        option.setAttribute('selected','');
                        selectedSet = true;
                    }
                }
            }
        }

        updateUrl(){
            if(this.displayedData.length > 0){
                var urlStr="?versions=";
                urlStr += this.displayedData[0];
            }
            if(this.displayedData.length > 1){
                urlStr += "&" + this.displayedData[1];
            }
            if(this.displayedData.length > 2){
                urlStr += "&" + this.displayedData[2];
            }
            if(this.displayedData.length > 3){
                urlStr += "&" + this.displayedData[3];
            }
            if(this.displayedData.length > 4){
                urlStr += "&" + this.displayedData[4];
            }
            history.replaceState(null, null, window.location.pathname + urlStr);
        }

        /* Gets the version and column when the select is changed */
        selectChangeEvent(event){
            /* Get the column to use from the select id */
            var selectId = event.target.getAttribute("id");
            var colNum = selectId.replace("npCompareGridSelect","");

            /* Get the version from the select value */
            var versionId = event.target.value;

            this.loadVersionData(colNum, versionId);
        }

        /* Loads version data into a column */
        loadVersionData(col,ver) {
            /* Will hold the version data */
            var versionData = null;

            /* find the data for one version */
            for(var i=0; i < this.loadedData.length; i++){
              if(this.loadedData[i].productIndex == ver){
                versionData = this.loadedData[i];
                break;
              }
            }

            /* If version data was found load it */
            if(typeof versionData === 'object' && versionData !== null){
                /* Loop through each object value */
                for (const [key, value] of Object.entries(versionData)) {

                    /* Determine if there is a row with the same key */
                    var rowElement = document.querySelector("np-compare-row[jsonfield='"+key+"']");
                    if(rowElement !=null ){

                        /* Determine if the column slot exists */
                        var slotExists = rowElement.querySelector("div[slot ='col"+col+"']") !== null;
                        var cell;

                        /* Reference/Create column slot */
                        if(slotExists){
                            cell = rowElement.querySelector("div[slot ='col"+col+"']");

                            /* Clear the previous value */
                            cell.innerHTML = "";
                        }else{
                            cell = document.createElement("div");
                            cell.setAttribute("slot","col"+col);
                            rowElement.appendChild(cell);
                        }

                        /* Check for renderer to display data in the cell */
                        if(rowElement.hasAttribute("renderer")){
                            /* call passed in renderer function */
                            this[rowElement.getAttribute("renderer")+"Renderer"](cell,value);
                        }else{
                            cell.innerHTML = value;
                        }
                    }
                }
            }else{
                /* No data found for this version - clear out old data */
                var colData = document.querySelectorAll("div[slot ='col"+col+"']");
                for(var i=0; i < colData.length; i++){
                    colData[i].innerHTML = "";
                }
            }


            /* Update the array that stores which version is displayed */
            this.displayedData[col] = ver;

            /* Update the url */
            this.updateUrl();
        }

        symbolRenderer(cell, value) {
            if(value == 'yes'){
                var symbol = document.createElement("np-compare-symbol");
                symbol.setAttribute("symbol","check");
                cell.appendChild(symbol);
            }else if(value == 'no'){
                var symbol = document.createElement("np-compare-symbol");
                symbol.setAttribute("symbol","x");
                cell.appendChild(symbol);
            }else if(value=='na'){
                var symbol = document.createElement("np-compare-symbol");
                symbol.setAttribute("symbol","dash");
                cell.appendChild(symbol);
            }else{
                cell.innerHTML=value;
            }
        }
        keyLinkRenderer(cell, value) {
            if(value == 'hardware'){
                cell.innerHTML = "<a class='hwKeyLink' href='"+window.location.origin+"/accessories/license-keys/#hardware-key'>$99<br>Hardware Key</a>";
            }else if(value =='security'){
                cell.innerHTML = "<a class='hwKeyLink' href='"+window.location.origin+"/accessories/license-keys/#security-key'>$149<br>Security Key</a>"
            }else{
                cell.innerHTML=value;
            }
        }

    } /* END class */

    window.customElements.define('np-compare-grid', NpCompareGrid);

  })();
